var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "School-edit" } },
    [
      _c(
        "Modal",
        {
          attrs: {
            title: _vm.modal.title,
            "footer-hide": "",
            "mask-closable": false,
          },
          model: {
            value: _vm.modal.visible,
            callback: function ($$v) {
              _vm.$set(_vm.modal, "visible", $$v)
            },
            expression: "modal.visible",
          },
        },
        [
          _c(
            "IForm",
            {
              key: _vm.modal.visible,
              ref: "formInline",
              attrs: {
                model: _vm.edit,
                elem: _vm.kindergartenElem,
                rules: _vm.kindergartenRule,
                loading: _vm.loading.form,
                "btn-loading": _vm.loading.btn,
                width: 450,
                "label-width": 120,
                button: "",
                "button-text": "取消",
              },
              on: {
                "on-submit": _vm.handleSubmit,
                "on-click": function ($event) {
                  _vm.modal.visible = false
                },
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "extend" }, slot: "extend" },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        "label-width": 120,
                        label: "幼儿园名称",
                        prop: "name",
                      },
                    },
                    [
                      _c("Input", {
                        staticStyle: { "font-size": "25px" },
                        attrs: {
                          type: "text",
                          placeholder: "请输入幼儿园名称",
                        },
                        model: {
                          value: _vm.edit.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.edit, "name", $$v)
                          },
                          expression: "edit.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        "label-width": 120,
                        label: "联系地址",
                        prop: "address",
                      },
                    },
                    [
                      _c("Input", {
                        staticStyle: { "font-size": "25px" },
                        attrs: { type: "text", placeholder: "请输入联系地址" },
                        model: {
                          value: _vm.edit.address,
                          callback: function ($$v) {
                            _vm.$set(_vm.edit, "address", $$v)
                          },
                          expression: "edit.address",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        "label-width": 120,
                        label: "联系电话",
                        prop: "phone",
                      },
                    },
                    [
                      _c("Input", {
                        staticStyle: { "font-size": "25px" },
                        attrs: { type: "text", placeholder: "请输入联系电话" },
                        model: {
                          value: _vm.edit.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.edit, "phone", $$v)
                          },
                          expression: "edit.phone",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        "label-width": 120,
                        label: "状态",
                        prop: "status",
                      },
                    },
                    [
                      _c(
                        "Select",
                        {
                          model: {
                            value: _vm.edit.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.edit, "status", $$v)
                            },
                            expression: "edit.status",
                          },
                        },
                        _vm._l(_vm.statusList, function (item) {
                          return _c(
                            "Option",
                            { key: item.value, attrs: { value: item.value } },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }